import React, { useEffect, useState } from "react";

/**
 * ThemeToggle
 * Drop this anywhere (e.g. in your nav). It flips a data-theme
 * attribute on <html>, which AmbientBackground.css reads to swap
 * every CSS variable (background, glass, text, glow colors, etc).
 *
 * Persists choice in localStorage and respects the user's OS
 * preference on first visit.
 *
 * Usage:
 *   import ThemeToggle from "./ThemeToggle";
 *   <ThemeToggle />
 */

const STORAGE_KEY = "av-theme";

function getInitialTheme() {
  if (typeof window === "undefined") return "dark";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === "dark" || saved === "light") return saved;
  const prefersLight = window.matchMedia(
    "(prefers-color-scheme: light)"
  ).matches;
  return prefersLight ? "light" : "dark";
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const isLight = theme === "light";

  return (
    <button
      type="button"
      className="av-theme-toggle"
      data-active={isLight}
      aria-label={`Switch to ${isLight ? "dark" : "light"} mode`}
      aria-pressed={isLight}
      onClick={() => setTheme(isLight ? "dark" : "light")}
    >
      <span className="av-theme-toggle-thumb">{isLight ? "☀" : "☾"}</span>
    </button>
  );
}
